// Unprotected routes
export const ROOT = '/';
export const LOGIN = '/login';
export const RESET_PASSWORD = '/reset-password';

export const SIGNUP = '/signup';
export const SIGNUP_PROFILE = '/signup/complete-profile';
export const SIGNUP_COMPANY = '/signup/company';
export const SIGNUP_COMPANY_MAIN_CONTACT = '/signup/company/main-contact';
export const SIGNUP_VERIFY_EMAIL = '/signup/verify-email';

export const EMAIL_VERIFICATION = '/email-verification';
export const PRODUCT_INFO = '/product-information';
export const PRODUCT_REG = '/register-product';
export const INVITE_PRODUCTS_REG = '/register-invite-products';
export const PRODUCT_REG_PROFESSIONAL = '/professional/product-registration';
export const CONFIRM_CHANGE_EMAIL = '/validate-change-email';
export const CONFIRM_DELETE_ACCOUNT = '/confirm-account-deletion';
export const TERMS_OF_USE = '/terms-of-use';

// Protected routes
export const PRODUCTS = '/my-products';
export const SERVICES = '/my-services';
export const PROFILE = '/my-profile';
export const PROFILE_EDIT = '/my-profile/edit';
